import { updateState } from '../../state-manager.js';
import { createClient } from '../../requests/clients.js'; // Assume this function exists to handle client registration
import { showLoginForm } from './ui-login.js';
// This module handles the registration UI and logic
// It provides functions to show the registration form and handle submission
// It also binds the submit button to handle registration logic

let isSubmitBound = false;
let isBackBound = false;

export function bindBackToLogin() {
  if (isBackBound) return;
  isBackBound = true;

  const backBtn = document.getElementById('back-to-login');
  if (!backBtn) return;

  backBtn.addEventListener('click', () => {
    console.log("Binding back to login button");
    showLoginForm({ showRegister: true });
  });
}


export function showRegistrationForm() {
  console.log("Showing registration form");
  document.getElementById('registration-container')?.classList.remove('hidden');
  document.getElementById('login-container')?.classList.add('hidden');
  
  bindBackToLogin();
  bindSubmitRegistration();
}

function bindSubmitRegistration() {
  if (isSubmitBound) return;
  isSubmitBound = true;

  const submitBtn = document.getElementById('submit-registration');
  console.log("Binding submit registration button");
  if (!submitBtn) return;

  // // Remove any existing listener before adding
  // submitBtn.replaceWith(submitBtn.cloneNode(true));
  // const newBtn = document.getElementById('submit-registration-btn');
  // if (!newBtn) return;
  // newBtn.classList.remove('hidden');
  // newBtn.classList.add('btn', 'btn-primary');

  submitBtn.addEventListener('click', async () => {
    const subscription = document.getElementById('subscription')?.value.trim();
    const firstName = document.getElementById('first_name')?.value.trim();
    const lastName = document.getElementById('last_name')?.value.trim();
    const email = document.getElementById('email')?.value.trim();
    let owner_nick = document.getElementById('owner_nick')?.value.trim();
    const nicksInput = document.getElementById('nicks')?.value.trim();
  
    if (!firstName || !lastName || !email) {
      alert('Please fill out all fields');
      return false;
    }

    // Validate email format
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(email)) {
      alert("Please enter a valid email address!");
      return;
    }
    
    // Use first name as default if the owner_nik is not provided
    if (!owner_nick) {
      owner_nick = firstName; 
    }
    
    // Split nicks by comma and trim whitespace
    let nicks = [owner_nick, ...(nicksInput ? nicksInput.split(",").map(n => n.trim()) : [])];
    const clientTypes = {
      'Free': 0,
      'Multi': 1,
      'Pro': 2
    }
    try {
      const { success, clientId, clientCode } = await createClient(
        clientTypes[subscription],
        firstName,
        lastName,
        email,
        owner_nick,
        nicks
      ); // implement this
      if (success) {
        updateState({ 
          clientId: clientId,
          clientCode: clientCode,
          nick: owner_nick,
          // nicks: nicks,
          is_owner: true,
        });
        showLoginForm({ showRegister: false }); // go to login with code pre-filled
      } else {
        alert("Registration failed. Try again.");
      }
    } catch (err) {
      console.error("Registration error:", err);
      alert("Something went wrong. Please try again.");
    }
  });
}